// frontend/shared-ui/src/forms/schemas/cleaner.js
export default {
    slug: 'cleaner',
    label: 'Fiber Optic Cleaners',
    defaultUnit: 'pcs',
    costDefaults: {
        avgVolumeCbm: 0.003,
        suggestedMarkupPct: 55,
        freightSensitivity: 'low',
        note: 'Pens and small kits — negligible freight burden',
    },
    groups: [
        {
            id: 'basic',
            label: 'Basic',
            columns: 2,
            fields: [
                { key: 'cleanerType', label: 'Cleaner Type', type: 'select', required: true, options: ['CLETOP-S Series', 'One-Click Cleaner', 'Alcohol Pads', 'Cleaning Kit'] },
                { key: 'connectorType', label: 'Compatible Connector', type: 'select', options: ['SC', 'LC', 'FC', 'ST', 'Universal'] },
                { key: 'packSize', label: 'Pack Size', type: 'number', unit: 'pcs' },
                { key: 'size', label: 'Size (for pads)', type: 'text', placeholder: '60mm x 30mm' },
                { key: 'alcoholContent', label: 'Alcohol Content', type: 'text', placeholder: '97%' },
            ],
        },
    ],
    buildSku(v) {
        const parts = ['CLN', v.cleanerType ? v.cleanerType.substring(0, 4).toUpperCase() : '', v.connectorType || ''];
        return parts.filter(Boolean).join('-').toUpperCase();
    },
    buildName(v) {
        const bits = [];
        if (v.alcoholContent) bits.push(v.alcoholContent);
        if (v.size) bits.push(v.size);
        if (v.connectorType) bits.push(v.connectorType);
        if (v.cleanerType) bits.push(v.cleanerType);
        if (v.packSize) bits.push(`(${v.packSize} pcs)`);
        return bits.join(' ');
    },
    attributeSchema: [
        { key: 'cleanerType', label: 'Cleaner Type' },
        { key: 'connectorType', label: 'Connector' },
        { key: 'packSize', label: 'Pack Size' },
        { key: 'size', label: 'Size' },
        { key: 'alcoholContent', label: 'Alcohol Content' },
    ],
};